<template>
<div class="table-view flex-fill mt-3 mb-3">
    <div class="container-fluid">
        <div class="container-fluid bg-secondary p-3">
            <table class="table table-dark table-striped mb-0 p-3">
                <thead>
                    <tr>
                    <th scope="col" class="text-start">City/Town</th>
                    <th scope="col" class="text-end">Customer Outage</th>
                    <th scope="col" class="text-end d-none d-md-block">Customer Served</th>
                    <th scope="col" class="text-end">Percent Out</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(city, idx) in mapData" :key="idx">
                        <th scope="row" class="text-start">{{ city.name }}</th>
                        <td class="text-end">{{ city.customers_affected }}</td>
                        <td class="text-end d-none d-md-block">{{ city.customers_serviced }}</td>
                        <td class="text-end">{{ city.percent_out }}%</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'Local',
  props: {
    mapData: Object
  }
}


</script>

<style>
.tr {
    border: none !important;
}

</style>